export default __webpack_public_path__ + "static/media/3-recogiendo-basura-en-el-parque.be1236ab.jpg";